import { HttpTransportType, HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import reduxSignalRMiddleware, { withCallbacks } from "_shared/_stores/realtime/redux-signalr-middleware";
import { getSignalRReconnectDelaysMs } from "_shared/_stores/realtime/signalr-reconnect-policy";
import Guid from "_shared/guids/guid";
import * as Config from "config";
import { MessageJSON } from "messaging/_schemas/message-schema";
import { addMessage, removeMessage } from "messaging/_stores/messages-redux-slice";
import Message from "messaging/message";
import Session from "users/__session/session";

export const messageHubConnection = new HubConnectionBuilder()
  .configureLogging(LogLevel.Debug)
  .withUrl(`${Config.apiBaseUrl}/messageHub`, {
    skipNegotiation: true,
    transport: HttpTransportType.WebSockets,
    accessTokenFactory: () => {
      return new Promise<string>((resolve, reject) => {
        const authToken = Session.loadFromStorage(() => {}).authToken?.value;
        if (authToken) {
          resolve(authToken);
        } else {
          reject(new Error("No token found"));
        }
      });
    },
  })
  .withAutomaticReconnect(getSignalRReconnectDelaysMs())
  .build();

const toMessage = (payload: unknown) =>
  Message.fromJSON({
    json: payload as MessageJSON,
  });

const callbacks = withCallbacks()
  .add("message-received", (payload: unknown) => (dispatch) => {
    const message = toMessage(payload);
    dispatch(addMessage(message));
  })
  .add("message-deleted", (payload: unknown) => (dispatch) => {
    const id = new Guid((payload as { id: string }).id);
    dispatch(removeMessage(id));
  });

export const messagesSignalRReduxMiddleware = reduxSignalRMiddleware({
  callbacks,
  connection: messageHubConnection,
  shouldConnectionStartImmediately: true,
});
